import { useState } from "react";
import {
  convertDateWithValidation,
  dateFormatterWithTime,
  validate,
} from "../../helper/losDataHelper";
import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const DynamicTemplate = ({ dynamicTemplateList }) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const maxSteps = validate(dynamicTemplateList)
    ? dynamicTemplateList.length
    : 0;

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const dynamicTemplateComponent = () => {
    const dynamicTemplateDetail = validate(dynamicTemplateList)
      ? dynamicTemplateList[activeStep]
      : undefined;
    return (
      <Grid container rowSpacing={0} columnSpacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Template Assessment ID"
            variant="standard"
            placeholder="Enter Template Assessment ID"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.templateAssessmentId
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Internal Application ID"
            variant="standard"
            placeholder="Enter Internal Application ID"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.internalApplicationId
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Business Assessment ID"
            variant="standard"
            placeholder="Enter Business Assessment ID"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.businessAssessmentId
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Template ID"
            variant="standard"
            placeholder="Enter Template ID"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.templateId
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Template Name"
            variant="standard"
            placeholder="Enter Template Name"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.templateName
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Business Type ID"
            variant="standard"
            placeholder="Enter Business Type ID"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.businessTypeId
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Business Type"
            variant="standard"
            placeholder="Enter Business Type"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.businessType
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Business Category ID"
            variant="standard"
            placeholder="Enter Business Category ID"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.businessCategoryId
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Business Category"
            variant="standard"
            placeholder="Enter Business Category"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.businessCategory
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Validity From"
            variant="standard"
            placeholder="Enter Validity From"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? convertDateWithValidation(dynamicTemplateDetail.validityFrom)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Validity To"
            variant="standard"
            placeholder="Enter Validity To"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? convertDateWithValidation(dynamicTemplateDetail.validityTo)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Active"
            variant="standard"
            placeholder="Enter Active"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.active
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Deleted"
            variant="standard"
            placeholder="Enter Deleted"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.deleted
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Approved"
            variant="standard"
            placeholder="Enter Approved"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.approved
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Remarked By"
            variant="standard"
            placeholder="Enter Remarked By"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.remarkedBy
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Remarks"
            variant="standard"
            placeholder="Enter Remarks"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.remarks
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Remarked Datetime"
            variant="standard"
            placeholder="Enter Remarked Datetime"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dateFormatterWithTime(dynamicTemplateDetail.remarkedDatetime)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Created By"
            variant="standard"
            placeholder="Enter Created By"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.createdBy
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Modified By"
            variant="standard"
            placeholder="Enter Modified By"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? dynamicTemplateDetail.modifiedBy
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Created Date"
            variant="standard"
            placeholder="Enter Created Date"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? convertDateWithValidation(dynamicTemplateDetail.createdDate)
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            type="text"
            label="Modified Date"
            variant="standard"
            placeholder="Enter Modified Date"
            disabled={true}
            value={
              dynamicTemplateDetail !== undefined
                ? convertDateWithValidation(dynamicTemplateDetail.modifiedDate)
                : ""
            }
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <AccordianContainer
      id="accord"
      title="Dynamic Template Details"
      initialOpen={false}
    >
      <Box sx={{ marginTop: "-1%" }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            {maxSteps > 1 && (
              <MobileStepper
                variant="text"
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }}
                nextButton={
                  <Button
                    size="small"
                    sx={{ color: "#003f7c" }}
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                    Next
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowLeft />
                    ) : (
                      <KeyboardArrowRight />
                    )}
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={handleBack}
                    sx={{ color: "#003f7c" }}
                    disabled={activeStep === 0}
                  >
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowRight />
                    ) : (
                      <KeyboardArrowLeft />
                    )}
                    Back
                  </Button>
                }
              />
            )}
          </Box>
        </Grid>
        {dynamicTemplateComponent()}
      </Box>
    </AccordianContainer>
  );
};

export default DynamicTemplate;
